{
  "contactModal": {
    "delete": {
      "cancel": "Annuler",
      "confirm": "Supprimer",
      "error": {
        "contactWithInformationRequests": "Impossible de supprimer le contact avec des demandes d'informations assignées",
        "default": "Erreur lors de la suppression du contact",
        "title": "Erreur lors de la suppression du contact"
      },
      "message": "Voulez-vous vraiment supprimer le partenaire commercial sélectionné ? Cette action est irrévocable.",
      "success": "Contact supprimé avec succès",
      "title": "Confirmation"
    }
  },
  "contacts": {
    "buttons": {
      "add": "Nouveau"
    },
    "table": {
      "headers": {
        "actions": "Actions",
        "email": "Contact Email",
        "id": "ID",
        "name": "Nom du site"
      }
    }
  },
  "onboarding": {
    "actions": {
      "activateAccount": "Activer le compte",
      "back": "← Retour",
      "next": "Suivant"
    },
    "ariaLabel": "Étapes d'intégration",
    "gate": {
      "retryBanner": {
        "message": "Une erreur est survenue. Veuillez rafraîchir et réessayer.",
        "retry": "Réessayer"
      }
    },
    "placeholder": "Contenu de l'étape bientôt disponible.",
    "stepIndicator": "Étape {{current}} sur {{total}}",
    "steps": {
      "my_facilities": {
        "name": "Sites",
        "subtitle": "Indiquez-nous quels sites de production vous utilisez et leur entreprise mère.",
        "title": "Ajoutez vos sites de production"
      },
      "register_bp": {
        "name": "Partenaires",
        "subtitle": "Listez les contacts clés des organisations partenaires — acheteurs, agents ou sous-traitants que nous devons contacter pour les demandes de traçabilité.",
        "title": "Ajoutez vos partenaires commerciaux"
      },
      "review": {
        "name": "Vérification",
        "subtitle": "Vérifiez que tout est correct avant d'activer votre compte.",
        "title": "Vérifiez vos informations"
      },
      "verify_company": {
        "name": "Vérifier l'entreprise",
        "subtitle": "Confirmez que nous avons la bonne entreprise avant de continuer.",
        "title": "Vérifiez le profil de votre entreprise"
      },
      "welcome": {
        "name": "Bienvenue",
        "subtitle": "",
        "title": "Bienvenue sur Trace for Good"
      }
    },
    "verifyCompany": {
      "outcomes": {
        "answer_on_behalf": {
          "description": "For consultants, agents or partners filling in for the company shown above. Next, you'll register your company — responses stay attributed to you as their agent.",
          "label": "This is not my company, but I'm responding on their behalf"
        },
        "claim_company": {
          "description": "Confirm the profile above and continue setup as an employee of this company.",
          "label": "Yes, this is my company — I'd like to validate it"
        },
        "not_related": {
          "description": "Stops this verification. The person who invited you to Trace For Good will be notified so they can rectify the company shown above.",
          "label": "This isn't my company"
        }
      },
      "prompt": "Is this the profile of the company you are working at?",
      "summary": {
        "city": "City",
        "country": "Country",
        "street": "Street"
      }
    },
    "welcome": {
      "checkInfo": "Avant d'accéder à votre compte Trace for Good, nous souhaitons vérifier quelques informations avec vous.",
      "intro": "Nous sommes ravis de vous accueillir. Ce portail a été conçu pour faciliter la collaboration entre partenaires commerciaux de différentes chaînes d'approvisionnement dans le contexte de la traçabilité des produits et de la conformité.",
      "invitation": "Vous avez été invité(e) sur la plateforme Trace for Good par <strong>{{invitingCompanyName}}</strong> pour participer à un processus de traçabilité produit. Ce processus peut vous demander de fournir des informations relatives aux chaînes d'approvisionnement."
    }
  },
  "productionSiteModal": {
    "actions": {
      "addRegistrationId": "Ajouter un identifiant professionnel",
      "backToProductionSite": "Retour au formulaire du site",
      "cancel": "Annuler",
      "delete": "Supprimer",
      "removeRegistrationId": "Supprimer un identifiant professionnel",
      "save": "Sauvegarder"
    },
    "createTitle": "Nouveau site",
    "delete": {
      "cancel": "Non",
      "confirm": "Oui",
      "message": "Êtes-vous sûr de vouloir supprimer ce site ?",
      "title": "Confirmation"
    },
    "editTitle": "Site",
    "errors": {
      "cityRequired": "La ville est requise",
      "coordinatesMaxDecimals": "La latitude et la longitude ne peuvent pas depasser 6 decimales",
      "countryMustBeValid": "Doit être un pays valide (ex. FR, DE)",
      "internalCodeTooLong": "Le code interne ne doit pas dépasser 32 caractères",
      "nameRequired": "Le nom est requis",
      "parentCompanyRequired": "L'entreprise mère est requise",
      "postalCodeTooShort": "Le code postal doit comporter au moins 3 caracteres",
      "streetRequired": "La rue est requise",
      "streetTooShort": "La rue doit comporter au moins 3 caracteres"
    },
    "labels": {
      "city": "Ville",
      "country": "Pays",
      "internalCode": "Autre code interne",
      "latitude": "Latitude",
      "longitude": "Longitude",
      "name": "Nom du site",
      "parentCompany": "Entreprise Mère",
      "performedActivities": "Activités",
      "postalCode": "Code postal",
      "registrationId": "Identifiants professionnels du site",
      "street": "Rue"
    },
    "parentCompanyChange": {
      "cancel": "Annuler",
      "confirm": "Confirmer",
      "message": "L'entreprise mère est l'entreprise à laquelle appartient ce site. La modifier mettra à jour la propriété de ce site et peut affecter le routage de la traçabilité.",
      "title": "Modifier l'entreprise mère ?"
    },
    "placeholders": {
      "city": "ex. Casablanca",
      "country": "Sélectionnez le pays du site",
      "internalCode": "ex. BD-DAK-001 ou votre référence interne",
      "latitude": "ex. 48.8566",
      "longitude": "ex. 2.3522",
      "name": "ex. Unité Coupe et Couture Dhaka A",
      "parentCompany": "ex. Trace for Good",
      "performedActivities": "ex. Coupe, couture, finition, teinture",
      "postalCode": "ex. 75008",
      "registrationId": "ex. N° TVA, CIN, GSTIN, USC",
      "street": "ex. 12 rue des Fleurs"
    },
    "registrationIdDescriptions": {
      "DUNS": "DUNS : 9 chiffres.",
      "EORI": "EORI : code pays + 14 chiffres.",
      "GLN": "GLN : 13 chiffres.",
      "OTHER": "Autre : max 32 caractères.",
      "RCS": "RCS : RCS + espace + nom entreprise + espace + [A,B] + espace + 9 chiffres.",
      "VAT": "TVA : code pays (ex. FR) + clé 2 chiffres + numéro SIREN 9 chiffres."
    },
    "registrationIdErrors": {
      "DUNS": "L'identifiant DUNS doit être un numéro à 9 chiffres.",
      "EORI": "L'identifiant EORI doit être au format : code pays (ex. FR) + 14 chiffres.",
      "GLN": "L'identifiant GLN doit être un numéro à 13 chiffres.",
      "OTHER": "L'identifiant autre doit contenir moins de 32 caractères.",
      "RCS": "L'identifiant RCS doit être au format : RCS + espace + nom entreprise + espace + [A,B] + espace + 9 chiffres.",
      "VAT": "L'identifiant TVA doit être au format : code pays (ex. FR) + clé 2 chiffres + numéro SIREN 9 chiffres."
    },
    "tabs": {
      "generalInfo": "Information",
      "location": "Localisation"
    },
    "tooltips": {
      "address": "Adresse complète du site. Sert à identifier et à tracer ce lieu dans vos dossiers.",
      "city": "Ville ou commune où se trouve le site.",
      "country": "Pays où le site est implanté.",
      "internalCode": "Code court interne que votre équipe utilise pour reconnaître ce site.",
      "latitude": "Facultatif : latitude du site en degrés décimaux (ex. 48.8566).",
      "longitude": "Facultatif : longitude du site en degrés décimaux (ex. 2.3522).",
      "name": "Nom utilisé en interne pour désigner ce site.",
      "parentCompany": "Entreprise propriétaire de l'usine, sélectionnée parmi les partenaires commerciaux enregistrés.",
      "parentCompanyEdit": "Sélectionnez l'entreprise propriétaire de ce site.",
      "parentCompanyReadOnly": "Seule l'organisation qui a créé ou possède ce site peut modifier l'entreprise mère.",
      "performedActivities": "Ce que fait le site (ex. transformation, conditionnement, stockage).",
      "postalCode": "Code postal du lieu où se trouve le site.",
      "registrationId": "Identifiant officiel ou d'immatriculation du site (TVA, CIN, GSTIN, USC, etc.).",
      "street": "Numéro et libellé de voie pour l'adresse du site."
    }
  },
  "productionSites": {
    "buttons": {
      "add": "Nouveau"
    },
    "create": {
      "error": "Erreur lors de la création du site",
      "successCreated": {
        "message": "Le site a été créé avec succès",
        "title": "Site créé"
      },
      "successMerged": {
        "message": "Un site existant a été trouvé et lié avec succès",
        "title": "Site lié"
      }
    },
    "delete": {
      "error": "Erreur lors de la suppression du site",
      "success": {
        "message": "Le site a été supprimé avec succès",
        "title": "Site supprimé"
      }
    },
    "filters": {
      "country": "Pays",
      "internalCode": "Autre code interne",
      "isConfidential": "Confidentiel",
      "isConfidentialFalse": "Non",
      "isConfidentialTrue": "Oui",
      "name": "Nom du site",
      "nothingFoundMessage": "nothingFoundMessage",
      "performedActivities": "Activités réalisées",
      "searchPlaceholder": "Rechercher les filtres",
      "title": "Filtres"
    },
    "search": {
      "placeholder": "Rechercher par nom ou adresse"
    },
    "sorts": {
      "address": "Localisation",
      "country": "Pays",
      "email": "Email",
      "internalCode": "Autre code interne",
      "name": "Nom"
    },
    "table": {
      "headers": {
        "address": "Localisation",
        "certificates": "Certificats",
        "deleted": "Supprimé",
        "id": "ID",
        "internalCode": "Autre code interne",
        "name": "Nom du site",
        "parentCompany": "Entreprise Mère",
        "performedActivities": "Activités",
        "registrationId": "Identifiants professionnels du site"
      }
    },
    "title": "Sites",
    "update": {
      "error": "Erreur lors de la mise a jour du site",
      "partialSave": {
        "message": "Le site a été mis à jour partiellement"
      },
      "success": {
        "message": "Le site a ete mis a jour avec succes",
        "title": "Site mis a jour"
      }
    }
  },
  "request": {
    "errors": {
      "generic": "Erreur"
    }
  }
}
